import type { ParticipantKeyContact } from '@piccolohealth/pbs-common';
import { Empty } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { FormSection } from '../../components/forms/FormSection';
import { LabelsStack } from '../../components/generic/LabelsStack';
import { ListItem } from '../../components/generic/ListItem';
import { UserAvatar } from '../../components/user/UserAvatar';

interface Props {
  keyContacts: ParticipantKeyContact[];
}

export const ParticipantProfileCardKeyContacts = (props: Props) => {
  const { keyContacts } = props;
  return (
    <FormSection heading='Key contacts'>
      {P.isEmpty(keyContacts) && <Empty h='full' title='No key contacts assigned yet' p={0} />}
      {keyContacts.map((keyContact) => {
        const secondary =
          P.compact([
            keyContact.description ?? 'Unknown relationship',
            keyContact.email,
            keyContact.phone,
          ]).join(', ') ?? '-';

        return (
          <ListItem
            key={keyContact.id}
            icon={
              <UserAvatar
                name={keyContact.name}
                secondary={secondary}
                w={10}
                h={10}
                showTooltip={false}
              />
            }
            title={keyContact.name}
            secondary={secondary}
            tertiary={<LabelsStack labels={keyContact.labels} />}
            right={null}
          />
        );
      })}
    </FormSection>
  );
};
